import '.ft{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fu{padding-left:1.5rem;}.ssr-plugin'
import '.fv{margin:1rem 0;}.ssr-plugin'
import '.fw{color:var(--gray-700);}.ssr-plugin'
import '.fx{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ft fu fv fw fx"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
